import Vue from 'vue';
import Router from 'vue-router';
import Index from '../views/Index';
import Avatamsaka from '../views/Avatamsaka';
import AvatamsakaIndex from '../components/Index';
import Contra from '../components/Contra';
import ChooseContra from '../components/ChooseContra';
import ChooseArticle from '../components/ChooseArticle';
import Article from '../components/Article';
import AvatamsakaIntro from '../components/Avatamsaka';
import ArticleVocabulary from '../components/ArticleVocabulary';
import Version from '../components/Version';
import Choose from '../components/Choose';
import ChooseIntro from '../components/ChooseIntro';
import Intro from '../components/Intro';
import Researcher from '../components/Researcher';
import History from '../components/History';
import About from '../components/About';
import AboutTeam from '../components/AboutTeam';
import ChooseCategory from '../components/ChooseCategory';
import Category from '../components/Category';
import CategorySutra from '../components/CategorySutra';
import DetailContrast from '../components/DetailContrast';
import DergeParkhang from '../components/DergeParkhang';
import Download from '../components/Download';
import Sutra01 from '../components/Sutra01';
import Sutra02 from '../components/Sutra02';

Vue.use(Router);

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '*',
      redirect: '/',
    },
    {
      path: '/',
      name: 'index',
      component: Index,
    },
    {
      path: '/avatamsaka',
      name: 'avatamsaka',
      component: Avatamsaka,
      children: [
        {
          path: '/',
          name: 'index',
          component: AvatamsakaIndex,
        },
        {
          path: '/avatamsaka/choose',
          name: 'choose',
          component: Choose,
        },
        {
          path: '/avatamsaka/researcher',
          name: 'researcher',
          component: Researcher,
        },
        {
          path: '/avatamsaka/about',
          name: 'about',
          component: About,
        },
        {
          path: '/avatamsaka/aboutTeam',
          name: 'aboutTeam',
          component: AboutTeam,
        },
        {
          path: '/avatamsaka/avatamsaka',
          name: 'avatamsakaIntro',
          component: AvatamsakaIntro,
        },
        {
          path: '/avatamsaka/history',
          name: 'history',
          component: History,
        },
        {
          path: '/avatamsaka/version/:vid?',
          name: 'version',
          component: Version,
        },
        {
          path: '/avatamsaka/chooseIntro',
          name: 'chooseIntro',
          component: ChooseIntro,
        },
        {
          path: '/avatamsaka/intro/:vid?',
          name: 'intro',
          component: Intro,
        },
        {
          path: '/avatamsaka/version/:vid?/sutra/:sid?/article',
          name: 'article',
          component: Article,
        },
        {
          path: '/avatamsaka/chooseArticle',
          name: 'chooseArticle',
          component: ChooseArticle,
        },
        {
          path: '/avatamsaka/version/:vid?/sutra/:sid?/articleVocabulary',
          name: 'articleVocabulary',
          component: ArticleVocabulary,
        },
        {
          path: '/avatamsaka/chooseContra',
          name: 'chooseContra',
          component: ChooseContra,
        },
        {
          path: '/avatamsaka/version/:vid?/sutra/:sid?/contra',
          name: 'contra',
          component: Contra,
        },
        {
          path: '/avatamsaka/chooseCategory',
          name: 'chooseCategory',
          component: ChooseCategory,
        },
        {
          path: '/avatamsaka/category/:vid?',
          name: 'category',
          component: Category,
        },
        {
          path: '/avatamsaka/category/:vid?/sutra/:sid',
          name: 'categorySutra',
          component: CategorySutra,
        },
        {
          path: '/avatamsaka/download',
          name: 'download',
          component: Download,
        },
        {
          path: '/avatamsaka/version/:vid?/sutra/:sid?/detail/:itemId',
          name: 'detailContrast',
          component: DetailContrast,
        },
        {
          path: '/avatamsaka/intro/1/DergeParkhang',
          name: 'dergeParkhang',
          component: DergeParkhang,
        },
        {
          path: '/avatamsaka/PurePractices',
          name: 'purePractices',
          component: Sutra01,
        },
        {
          path: '/avatamsaka/TheTenBhumis',
          name: 'theTenBhumis',
          component: Sutra02,
        },
      ],
    },
  ],
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    }
    return { x: 0, y: 0 };
  },
});



// WEBPACK FOOTER //
// ./src/router/index.js